import isMobile from 'ismobilejs';
import Sticky from 'sticky-js';

export default {
	render_sticky() {
		$('.add_sticky').attr('data-sticky-class', 'is-sticky');
		new Sticky('.add_sticky');
	},
	init() {
		var _this = this;
		// JavaScript to be fired on all pages
		$('[data-toggle="tooltip"]').tooltip();
		$('[data-bs-toggle="tooltip"]').tooltip();

		$( document.body ).on( 'updated_checkout', function ( ) {
			$('[data-toggle="tooltip"]').tooltip();
			$('[data-bs-toggle="tooltip"]').tooltip();
			/*
			console.log(22);
			setTimeout( function () {
				console.log( $('#payment .blockUI' ).length );
			}, 500 );
			*/
			$( '#radio_lugar_forma_pago_field input').change( function ( ) {
				console.log( $('#payment .blockUI' ).length );
				if( !$('#payment .blockUI' ).length ) {
					$( document.body ).trigger( 'update_checkout' );
				}
			});
		});

		$('.sidebar').attr('data-sticky-container', '');
		$('.add_sticky').addClass('is-sticky');
		var $window = $(window);
		if (!isMobile.any) {
			_this.render_sticky();
		}
		setTimeout(function() {
			if (!isMobile.any) {
				_this.render_sticky();
			}
		}, 2000);
		$window.resize(function() {
			if (!isMobile.any) {
				_this.render_sticky();
			}
		} );

		/* MIGRADO */
		$(document).on( 'click', '.menu-item.menu-item-has-children a[href="#"]', function ( e ) {
			e.preventDefault();
			console.log( 1 );
			$(this).closest('.menu-item').toggleClass('openMenu');
		} );
		$(document).on( 'click', '.menu-item.menu-item-has-children .style_nav', function ( e ) {
			e.preventDefault();
			e.stopPropagation();
			console.log( 2 );
			$(this).closest('.menu-item').toggleClass('openMenu');
		} );

		$('.mejs-container').on('contextmenu',function(){
			return false;
		});
		$('body').on('contextmenu',function(){
			return false;
		});

		if( window.innerWidth <= 1259 ) {
			$('#navbarSupportedContent').css('top', $('.banner > .container-full').height() );
		} else {
			$('#navbarSupportedContent').removeAttr('style');
		}

		/*
		$('[name="field_5c192c17607be"]').datepicker({
			endDate: 'now',
			format: 'dd/mm/yyyy',
			language: 'es',
			autoclose: true,
		});
		*/
		$('[name="field_5c0ad555a4376"]').change( function () {
			var value = $(this).val();
			if ( value != 'Otra profesional' ) {
				$('.field_profesion').val('');
				$('.field_profesion').fadeOut(0);
			} else {
				$('.field_profesion').fadeIn(0);
			}
		} );

		$( '#open_register_institucion [name="telefono_institucion"]' ).change( function () {
			if( $( '#open_register_institucion #defaultCheck12' ).is(':checked') ) {
				$( '#open_register_institucion [name="telefono_contacto_institucion"]' ).val( $(this).val() );
			}
		} );
		$( '#open_register_institucion #defaultCheck12' ).change( function () {
			if( $(this).is(':checked') ) {
				$( '#open_register_institucion [name="telefono_contacto_institucion"]' ).val( $( '#open_register_institucion [name="telefono_institucion"]' ).val() );
			} else {
				$( '#open_register_institucion [name="telefono_contacto_institucion"]' ).val( '' );
			}
		});


		if( !$('body').hasClass('logged-in') && window.ajax_object.open_login ) {
			$.magnificPopup.open({
				items: {
					src: '#open_login_register',
					type: 'inline',
				},
				type:'inline',
				//mainClass:'openAyuda',
				midClick: true,
				fixedContentPos: true,
				fixedBgPos: true,
				closeOnContentClick: false,
				closeOnBgClick: false,
				closeBtnInside: false,
				showCloseBtn: false,
				enableEscapeKey: false,
			});
		}
		if ( $('body').hasClass('logged-in') && window.ajax_object.open_completar ) {
			$.magnificPopup.open({
				items: {
					src: '#completar_registro',
					type: 'inline',
				},
				type:'inline',
				mainClass:'openAyuda',
				midClick: true,
				fixedContentPos: true,
				fixedBgPos: true,
				closeOnContentClick: false,
				closeOnBgClick: false,
				closeBtnInside: false,
				showCloseBtn: false,
				enableEscapeKey: false,
				callbacks: {
					open: function() {
						$('select[name="field_5c0ad582f3773"]').change( function () {
							var $option = $('select[name="field_5c0ad582f3773"] option:selected');
							$('input[name="field_5c0ad591f3775"]').val( $option.data('numero'));
						} );
					},
					close: function() {
						$('select[name="field_5c0ad582f3773"]').off('change');
					},
				},
			});
		}

		var validateNumber = function (event) {
			if (event.keyCode === 46 || event.keyCode === 8 || event.keyCode === 9 || event.keyCode === 27 || event.keyCode === 13 ||
				// Allow: Ctrl+A
				(event.keyCode === 65 && event.ctrlKey === true) ||
				// Allow: home, end, left, right
				(event.keyCode >= 35 && event.keyCode <= 39)) {
				// let it happen, don't do anything
				return;
			}
			else {
				// Ensure that it is a number and stop the keypress
				if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
					event.preventDefault();
				}
			}
		};
		$('.onlyNumber').keydown( validateNumber );
		var submit_error = function( error_message, $form ) {
			$( '.message-result' ).remove();
			$form.prepend( error_message );
			$form.removeClass( 'processing' );
			$form.find( '.input-text, select' ).blur();
			//$.scrollTo( $form.offset().top - 100 );
		};

		$('#completar_registro_form #no_trabajo').change( function ( ) {
			if( $(this).is(':checked') ) {
				$('[name="tipo_colegio"]').removeAttr('checked');
				$('[name="tipo_colegio"]').removeAttr('required');
				$('[name="tipo_colegio"]').removeClass('required');
				$('[name="tipo_colegio"]').attr('disabled', 'disabled');
			} else {
				$('[name="tipo_colegio"]').addClass('required');
				$('[name="tipo_colegio"]').attr('required', 'required');
				$('[name="tipo_colegio"]').removeAttr('disabled');
			}
		});

		$('#completar_registro_form [name="field_5c0ad555a4376"]').change( function ( ) {
			var val = $(this).val();
			if( val == 'Maestra' || val == 'Auxiliar' || val == 'Promotora' || val == 'Directora' ) {
				$('.checked_trabajo_en').fadeIn(0);
				$('.checed_notrabajo').fadeIn(0);

				$('#completar_registro_form #no_trabajo').change();
			} else {
				$('.checked_trabajo_en').fadeOut(0);
				$('.checed_notrabajo').fadeOut(0);

				$('[name="tipo_colegio"]').removeAttr('checked');
				$('[name="tipo_colegio"]').removeAttr('required');
				$('[name="tipo_colegio"]').removeClass('required');
			}
		});
		
		$('#completar_registro_form').submit( function ( e ) {
			e.preventDefault();
			var $form = $( this );
			if ( $form.hasClass('processing') ) {
				return;
			}

			$('#completar_registro').block({ message: '' });

			$form.addClass( 'processing' );
			$form.find('.btn-primary').attr('disabled', 'disabled');
			//$form.find('.btn-primary').removeAttr('disabled');
			var existsError = false;
			$form.find('.form-control.required').each( function( index, _control ) {
				var control = $( _control );
				control.removeClass('has-error').parent().removeClass('has-error');
				if ( control.hasClass('required') && ( !control.val() || control.val() === -1 ) ){
					control.addClass('has-error').parent().addClass('has-error');
					existsError = true;
				}
			} );
			$form.find('.form-check-input.required').each( function( index, _control ) {
				var control = $( _control );
				control.removeClass('has-error').parent().removeClass('has-error');
				var name_input = control.attr('name');
				var unique_control = $form.find('.form-check-input.required[name="'+ name_input +'"]');
				if ( control.hasClass('required') && !unique_control.is(':checked') ){
					control.addClass('has-error').parent().addClass('has-error');
					existsError = true;	
				}
			} );
			$form.find('[name="field_5c0ad591f3775"].required').each( function( index, _control ) {
				var control = $( _control );
				control.removeClass('has-error').parent().removeClass('has-error');
				if ( control.hasClass('required') && ( !control.val() || control.val() === -1 ) ){
					control.addClass('has-error').parent().addClass('has-error');
					existsError = true;
				} else {
					if( control.val().length < 7 ) {
						control.addClass('has-error').parent().addClass('has-error');
						existsError = true;
					}
				}
			} );
			if ( existsError ) {
				$form.removeClass( 'processing' );
				$form.find('.btn-primary').removeAttr('disabled');
				$('#completar_registro').unblock();
				return;
			}
			$.ajax({
				type:		'POST',
				url:		window.ajax_object.ajax_url,
				data:		$form.serialize(),
				dataType:	'json',
				success:	function( result ) {
					try{
						if ( result.result === 'success' ) {
							$('#completar_registro').unblock();
							$form.removeClass( 'processing' );
							$form.find('.btn-primary').removeAttr('disabled');
							if ( result.messages ) {
								var msg = 'Tu información ha sido guardada satisfactoriamente. Gracias.';
								submit_error( '<div class="alert alert-success">' + msg + '</div>', $form );
							}
							$form[0].reset();
							setTimeout( function () {
								$.magnificPopup.close();
								location.reload();
							}, 4500 );
							return;
						} else if ( result.result === 'failure' ) {
							throw 'Result failure';
						} else {
							throw 'Invalid response';
						}
					} catch( err ){
						$('#completar_registro').unblock();
						console.log( err );
						$form.removeClass( 'processing' );
						$form.find('.btn-primary').removeAttr('disabled');
					}
				},
				error:	function( ) {
					$('#completar_registro').unblock();
					submit_error( '<div class="alert alert-danger">Ocurrió un error a la hora de enviar sus datos</div>', $form );
					$form.removeClass( 'processing' );
					$form.find('.btn-primary').removeAttr('disabled');
				},
			});
		} );
		
		$(document).on( 'click', '.woocommerce-MyAccount-content .wrapper', function ( e ) {
			e.preventDefault();
			var url = $(this).data('pdf');
			window.open(url, '_blank');
		} );
		$(document).on( 'click', '.navbar-toggler', function ( e ) {
			e.preventDefault();
			$('#navbarSupportedContent').toggleClass('openleft');
			
			if( jQuery('#navbarSupportedContent').hasClass('openleft') ) {
				$('body').css( {
					'overflow-y': 'auto',
				} );
			} else {
				$('body').css( {
					'overflow-y': 'auto',
				} );
			}
		} );
		$('#open_login_register .login_form').submit( function ( e ) {
			var $form = $(this);
			e.preventDefault();
			$form.find('.alert').remove();
			var data = {
				'action': 'loginWithEmail',
				'email': $form.find('[name="log"]').val(),
				'password': $form.find('[name="pwd"]').val(),
			};
			jQuery.post(window.ajax_object.ajax_url, data, function(response) {
				if ( response.result == 'success' ) {
					$form.prepend('<div class="alert alert-success" style="padding-top: 0.3em; padding-bottom: 0.1em; " role="alert">'+response.msg+'</div>');
					setTimeout( function ( ) {
						location.reload();
					}, 100 );
				}
				else {
					$form.prepend('<div class="alert alert-danger" style="padding-top: 0.3em; padding-bottom: 0.1em; " role="alert">'+response.msg+'</div>');
				}
			});
		} );

		$( document ).on( 'click', '.woocommerce-notices-wrapper .close-button', function(){
			$('.woocommerce-notices-wrapper').fadeOut(function(){$(this).html(''); $(this).fadeIn(0) });
		});
		$(document).on('submit', 'body.registrar_asistentes form[action="#registrar_asisntentes"]', function() {
			$.blockUI({ message: '' });
		} );

		$(document).on( 'click', '.openPublicar a, .openPublicar_2, body:not(.logged-in) .open_login a', function ( e ) {
			e.preventDefault();
			$('.open_login_register').click();
			$('.mfp-content [data-redirect="current"]').attr( 'data-redirect', $(this).attr('href') );
			setTimeout( function () {
				$('.mfp-content [data-redirect="current"]').attr( 'data-redirect', $(this).attr('href') );
			}, 500 );
		} );
		$('.open_login_register, .open_register').magnificPopup({
			'type': 'inline',
			'midClick': true,
			'fixedContentPos': true,
			'fixedBgPos': true,
		});
		$(document).on( 'click', 'a.go_top', function ( e ) {
			e.preventDefault();
			$('html, body').animate({
				scrollTop: 0,
			}, 1500);
		});

		$('.onlyNumbers').on('keypress keyup blur',function (event) {
			$(this).val($(this).val().replace(/[^\d].+/, ''));
			if ((event.which < 48 || event.which > 57)) {
				event.preventDefault();
			}
		});

		window.closebanner = function () {
			document.getElementById('close_button').click();
		};

		$(document).on('click',function(e) {
			var container = $('#navbarSupportedContent');
			var navbar_toggler = $('.navbar-toggler');
			if (!navbar_toggler.is(e.target) && !container.is(e.target) && navbar_toggler.has(e.target).length === 0 && container.has(e.target).length === 0) { 
				if( container.hasClass('openleft') ) {
					container.toggleClass('openleft');
					$('body').css( {
						'overflow-y': 'auto',
					} );
				}
			}
		});

		$(document).on( 'click', '.open_inicia_sesion_register', function ( e ) {
			e.preventDefault();
			$('.show_login_register').fadeToggle( 0 );
		} );
		$(document).on( 'click', '.show_login_form', function ( e ) {
			e.preventDefault();
			$('.register_form').fadeOut( 0 );
			$('.login_form').fadeIn( 0 );
		} );
		$(document).on( 'click', '.show_register_form', function ( e ) {
			e.preventDefault();
			$('.login_form').fadeOut( 0 );
			$('.register_form').fadeIn( 0 );
		} );
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		$( '.input-ciudad' ).autocomplete({
			source: typeof window.WC_Vars.availableCities === 'undefined' ? [] : window.WC_Vars.availableCities,
		});
		$('.input-dni').change( function ( ) {
			var $input = $(this);
			console.log( $(this).val() );
			if( $(this).val().trim().length == 8 ) {
				var url = window.ajax_object.ajax_url;
				$input.closest('.form-row').find('.input-nombre').attr('disabled', 'disabled');
				$input.closest('.form-row').find('.input-apellido').attr('disabled', 'disabled');
				$input.closest('.form-row').find('.input-correo').attr('disabled', 'disabled');
				$input.closest('.form-row').find('.input-celular').attr('disabled', 'disabled');
				$input.closest('.form-row').find('.input-edad').attr('disabled', 'disabled');
				$.ajax({
					type: 'POST',
					data:{
						action: 'consultar_nombre_2',
						dni: $(this).val(),
					},
					url: url,
					success: function(datos_dni){
						console.log( datos_dni );
						var datos = JSON.parse(datos_dni.trim());
						console.log( datos );
						$input.closest('.form-row').find('.input-nombre').removeAttr('disabled');
						$input.closest('.form-row').find('.input-apellido').removeAttr('disabled');
						$input.closest('.form-row').find('.input-correo').removeAttr('disabled');
						$input.closest('.form-row').find('.input-celular').removeAttr('disabled');
						$input.closest('.form-row').find('.input-edad').removeAttr('disabled');
						if( datos.nombres == '' ) {
							$input.after('<span style="color: red;"> DNI no encontrado.</span>');
							setTimeout( function () {
								$input.next().remove();
							}, 2000 );
							$input.closest('.form-row').find('.input-nombre').val('');
							$input.closest('.form-row').find('.input-apellido').val('');
							$input.closest('.form-row').find('.input-correo').val('');
							//$input.closest('.form-row').find('.input-celular').val('');
							$input.closest('.form-row').find('.input-edad').val('');
						} else {
							$input.closest('.form-row').find('.input-nombre').val(datos.nombres);
							$input.closest('.form-row').find('.input-apellido').val(datos.apellidos);
							$input.closest('.form-row').find('.input-correo').val(datos.correo);
							//$input.closest('.form-row').find('.input-celular').val(datos.celular);
							$input.closest('.form-row').find('.input-edad').val(datos.edad);
						}
					},
					error:	function( ) {
						$input.closest('.form-row').find('.input-nombre').removeAttr('disabled');
						$input.closest('.form-row').find('.input-apellido').removeAttr('disabled');
						$input.closest('.form-row').find('.input-correo').removeAttr('disabled');
						$input.closest('.form-row').find('.input-celular').removeAttr('disabled');
						$input.closest('.form-row').find('.input-edad').removeAttr('disabled');

						$input.after('<span style="color: red;">DNI no encontrado.</span>');
						setTimeout( function () {
							$input.next().remove();
						}, 2000 );
					},
				});
			} 
		} );

		if (window.location.hash) {
			var hash = window.location.hash;
			setTimeout( function () {
				if ($(hash).length) {
					$('html, body').animate({
						scrollTop: $(hash).offset().top - 10,
					}, 900, 'swing');
				}
			}, 500 );
		}
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js